import React from 'react';
import { B2BOrganization } from 'types/b2b-organization';
import { ListItem } from './list-tem';
import { ListClassName } from './style';

type ListProps = {
  model: B2BOrganization[];
  currentOrganizationNumber: string;
  onChangeSelected: (value: string) => void;
};

export const List = (props: ListProps) => {
  return (
    <div className={ListClassName}>
      {props.model.map((item) => {
        return (
          <ListItem
            key={item.organizationNumber}
            item={item}
            isSelected={props.currentOrganizationNumber === item.organizationNumber}
            onChangeSelected={props.onChangeSelected}
          />
        );
      })}
    </div>
  );
};
